import { FormElement } from '../../formElement';
import { FormGroup } from '../../formGroup';
import { WithOptional } from '../../utility';

type ConfigProps = WithOptional<
    GenerationUnitsFeedbackFormGroup,
    keyof FormGroup
>;

export class GenerationUnitsFeedbackFormGroup extends FormGroup {
    public readonly generationUnitsFeedbackHeadline: FormElement;
    public readonly generationUnitsFeedbackInfoText: FormElement;
    public readonly generationUnitsFeedbackButton: FormElement;

    public constructor(config: ConfigProps) {
        super(config);

        this.generationUnitsFeedbackHeadline =
            config.generationUnitsFeedbackHeadline;
        this.generationUnitsFeedbackInfoText =
            config.generationUnitsFeedbackInfoText;
        this.generationUnitsFeedbackButton =
            config.generationUnitsFeedbackButton;
    }
}
